import { render } from "./RefundGuide.vue?vue&type=template&id=01df9764&scoped=true"
import script from "./RefundGuide.vue?vue&type=script&lang=js"
export * from "./RefundGuide.vue?vue&type=script&lang=js"

import "./RefundGuide.vue?vue&type=style&index=0&id=01df9764&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01df9764"]])

export default __exports__